<script lang="ts">
import FicheVirementsRecu from '@/generated/fiches/FicheVirementsRecu.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheVirementsRecu
})

</script>
